import { CentraSelectionItem } from "@made-people/centra-checkout-api";

export interface TableMapping {
  unit: string;
  x: Record<string, string> | string[];
  y: Record<string, string> | string[];
  dividerSymbol: string;
}

export function getLocalizedItemSize(
  itemSize: string,
  tableMapping: TableMapping,
): string {
  const dividerSymbol = tableMapping.dividerSymbol;

  const globalXSize = itemSize.split(dividerSymbol)[0];
  const globalYSize = itemSize.split(dividerSymbol)[1];

  if (!globalXSize && !globalYSize) {
    return itemSize;
  }

  const xSize = Array.isArray(tableMapping.x)
    ? undefined
    : tableMapping.x[globalXSize];

  const ySize = Array.isArray(tableMapping.y)
    ? undefined
    : tableMapping.y[globalYSize];

  if (xSize && ySize) {
    return `${xSize}${dividerSymbol}${ySize}`;
  }

  if (xSize) {
    return xSize;
  }

  return itemSize;
}

export function getLocalizedItemSizeFromSelectionItem(
  item: CentraSelectionItem,
  tableMapping: TableMapping,
): string {
  const currentProductItem = item.product.items.find(
    (productItem) => productItem.item === item.item,
  );

  if (!currentProductItem) {
    return item.size;
  }

  return getLocalizedItemSize(item.size, tableMapping);
}
